module.exports = __webpack_public_path__ + "img/sty_3.d5f7df29.webp";